module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/as-7ae00cb9d6bf497132c195ddecfc9ecc.svg";